'use client';

import * as React from 'react';
import { Progress as BaseProgress } from '@base-ui/react/progress';
import styles from './Progress.module.css';
import clsx from 'clsx';

export interface ProgressProps {
  value?: number;
  max?: number;
  label?: string;
  showValue?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'success' | 'warning' | 'danger';
  indeterminate?: boolean;
  className?: string;
}

export const Progress: React.FC<ProgressProps> = ({
  value = 0,
  max = 100,
  label,
  showValue = false,
  size = 'md',
  color = 'primary',
  indeterminate = false,
  className,
}) => {
  const percentage = Math.round((value / max) * 100);

  return (
    <div className={clsx(styles.container, className)}>
      {(label || showValue) && (
        <div className={styles.header}>
          {label && <span className={styles.label}>{label}</span>}
          {showValue && !indeterminate && (
            <span className={styles.value}>{percentage}%</span>
          )}
        </div>
      )}
      <BaseProgress.Root
        value={indeterminate ? null : value}
        max={max}
        className={clsx(styles.track, styles[size])}
      >
        <BaseProgress.Indicator
          className={clsx(
            styles.indicator,
            styles[color],
            indeterminate && styles.indeterminate
          )}
        />
      </BaseProgress.Root>
    </div>
  );
};
